import * as LucideIcons from 'lucide-react';

export const getIcon = (iconName, props = {}) => {
  const Icon = LucideIcons[iconName];
  if (!Icon) {
    console.warn(`Icon '${iconName}' not found`);
    return LucideIcons.Circle;
  }
  return Icon;
};

export const renderIcon = (iconName, props = {}) => {
  const Icon = getIcon(iconName);
  return <Icon {...props} />;
};
